import React from 'react';
import { withTranslation } from 'react-i18next';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { makeStyles } from '@mui/styles';
import { useTheme } from '@mui/material/styles';
import Container from '@mui/material/Container';
import { Login } from '../helpers/helper.js';
import { useState } from 'react';
import bgImage from "../assets/login-page-bg.jpg";
import brandLogo from "../assets/xperience-brand.png";
import packageJson from '../../package.json';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { Alert } from '@mui/material';

const useStyles = makeStyles((theme) => ({
    root: {
        "& .MuiFilledInput-root": {
            background: "rgb(232, 241, 250)"
        }
    },
    main: {
        height: '100vh',
        backgroundImage: "url(" + bgImage + ")",
        backgroundSize: 'cover',
        backgroundPosition: 'center'
    },
    paper: {
        paddingTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
    subTitle: {
        color: '#efefef'
    },
    input: {
        backgroundColor: '#efefef',
    },
    brand: {
        height: "60px",
    }
}));

function Copyright() {
    const theme = useTheme()
    const classes = useStyles(theme);
    return (
        <Container>
            <Typography className={classes.subTitle} variant="body2" color="textSecondary" align="center">
                {'Copyright © '}
                <Link color="inherit" href="https://umpi.it/">
                    Umpi S.r.l.
                </Link>{' '}
                {new Date().getFullYear()}
                {'.'}
            </Typography>
            <Typography className={classes.subTitle} variant="body2" color="textSecondary" align="center">
                {packageJson.version}
            </Typography>
        </Container>
    );
}

function SignIn(props) {
    const [open, setOpen] = useState(false);
    const [alert, setAlert] = useState('');
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');

    const theme = useTheme()
    const classes = useStyles(theme);

    async function handleSubmit(event) {
        event.preventDefault();
        setOpen(true);
        setAlert('');
        let res = await Login(username, password);

        if (res.data.errors || res.data.error || res.status === 404 || res.status === 401 ) {
            props.updateLoginState({ "loggedInStatus": "NOT_LOGGED_IN" });
            setOpen(false);
            setAlert(<Alert severity="warning">{props.t("login_failed")}</Alert>);
            return;
        }

        localStorage.setItem('access_token', res.data.rows[0].token);
        //localStorage.setItem('userId', 84);
        props.updateLoginState({ "loggedInStatus": "LOGGED_IN" });
        return;
    }

    return (
        <div>
            <Backdrop
                sx={{ color: '#fff', zIndex: (useTheme().zIndex.drawer + 1) }}
                open={open}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <Container maxWidth={false} disableGutters={true} className={classes.main}>
                <Container component="main" maxWidth="xs">
                    <CssBaseline />
                    <div className={classes.paper}>
                        <Box
                            component="img"
                            className={classes.brand}
                            alt=""
                            src={brandLogo}
                        />
                        <Typography className={classes.subTitle} component="h3" variant="h7">
                            {props.t("installation_and_maintenance")}
                        </Typography>
                        <Typography className={classes.subTitle} component="h1" variant="h5">
                            {props.t("authentication")}
                        </Typography>
                        <form className={classes.form} noValidate onSubmit={handleSubmit}>
                            <TextField
                                className={classes.root}
                                variant="filled"
                                margin="normal"
                                required
                                fullWidth
                                id="email"
                                label={props.t("email_address")}
                                name="email"
                                autoComplete="email"
                                autoFocus
                                value={username}
                                onChange={(e) => { setUsername(e.target.value) }}
                            />
                            <TextField
                                className={classes.root}
                                variant="filled"
                                margin="normal"
                                required
                                fullWidth
                                name="password"
                                label={props.t("password")}
                                type="password"
                                id="password"
                                autoComplete="current-password"
                                value={password}
                                onChange={(e) => { setPassword(e.target.value) }}
                            />
                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                color="primary"
                                className={classes.submit}>
                                {props.t("sign_in")}
                            </Button>
                        </form>
                    </div>
                    <Box mt={8}>
                        <Copyright />
                    </Box>
                    <Box>{alert}</Box>
                </Container>
            </Container>
        </div>
    );
}

export default withTranslation()(SignIn);
